import once from '@drupal/once'
import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"
import persist from "@alpinejs/persist"

Alpine.plugin(collapse);
Alpine.plugin(persist);
window.Alpine = Alpine;
Alpine.start();

var $component = once('processed', '.component-header-menu').shift();
if ($component) {
  import('../../templates/component/header-menu/js/header-menu')
}
var $component = once('processed', '.component-header-search').shift();
if ($component) {
  import('../../templates/component/header-search/js/header-search')
}
var $component = once('processed', '.component-accordion').shift();
if ($component) {
  import('../../templates/component/accordion/js/accordion')
}
var $component = once('processed', '.component-accordion-simple').shift();
if ($component) {
  import('../../templates/component/accordion-simple/js/accordion-simple')
}
var $component = once('processed', '.component-gallery').shift();
if ($component) {
  import('../../templates/component/gallery/js/gallery')
}
var $component = once('processed', '.component-article-comment-form').shift();
if ($component) {
  import('../../templates/component/article-comment-form/js/article-comment-form')
}
var $component = once('processed', '.component-image').shift();
if ($component) {
  import('../../src/js/wordpress-core-image')
}

